import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import { Card, Grid, Stack, Tooltip, Typography } from "@mui/material";
import jwtAuthAxios from "app/services/auth/jwtAuth";
import NoDataPlaceholder from "app/shared/NoDataPlaceholder";
import SalesOverview from "app/shared/metrics/SalesOverview";
import UserOrders from "app/shared/metrics/UserOrders";
import Documents1 from "app/shared/widgets/Documents1";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import Ideas1 from "app/shared/widgets/Ideas1";
import DiamondIcon from "@mui/icons-material/Diamond";

import TableSkeleton from "app/shared/widgets/TableSkeleton";
import UserSummary from "app/shared/widgets/UserSummary";
import React, { useEffect, useState } from "react";
import UserProfileCard1 from "app/shared/widgets/UserProfileCard1";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import renderSalesData from "app/shared/metrics/SalesStatistics/renderSalesData";
import JumboContent from "@jumbo/components/JumboContent";
import JumboDdMenu from "@jumbo/components/JumboDdMenu";
import Div from "@jumbo/shared/Div";
import LineChartSales from "app/shared/metrics/SalesStatistics/LineChartSales";
import { useTheme } from "@emotion/react";
import ChartOrderRevenue from "app/shared/metrics/SalesStatistics/ChartOrderRevenue";
import {
  adminDataItems,
  dataItems,
} from "app/shared/metrics/SalesStatistics/data";
import { DateRangeIcon } from "@mui/x-date-pickers";
import styled from "@emotion/styled";
import {
  CartesianGrid,
  Label,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import { capitalizeFLetter } from "@jumbo/utils";
import ChartYearlyProfit from "app/shared/metrics/YearlyProfitReport/ChartYearlyProfit";
import YearlyProfileReport from "app/shared/metrics/YearlyProfitReport/YearlyProfileReport";
import CitiesGraph from "app/shared/metrics/Cities/CitiesGraph";
import Cities from "app/shared/metrics/Cities";
import Properties from "app/shared/metrics/Properties";
import OnlineVisitors from "app/shared/metrics/OnlineVisitors";
import VisitsStatistics from "app/shared/metrics/VisitsStatistics";
import QueriesStatistics from "app/shared/metrics/QueriesStatistics";
import AdminDashboard from "./adminDashboard";
import AccountDashboard from "./accountDashboard";
import SalesmanDashboard from "./salesmanDashboard";
import UserDashboard from "./userDashboard";

// export const AdminData = [
//   {
//     name: "Total Sales",
//     amount: "48,548",
//   },
//   {
//     name: "Total Memo",
//     amount: "6,478",
//   },
//   {
//     name: "Total Purchase",
//     amount: "$210,213",
//   },
//   {
//     name: "Total consignment",
//     amount: "$692,874",
//   },
//   {
//     name: "Total Payable",
//     amount: "$692,874",
//   },
//   {
//     name: "Total Receivable",
//     amount: "$692,874",
//   },
//   {
//     name: "Total Single Stock",
//     amount: "$692,874",
//   },
//   {
//     name: "Total Bulk Stock",
//     amount: "$692,874",
//   },
//   {
//     name: "Total Jewelry Stock",
//     amount: "$692,874",
//   },
// ];
const Dashboard = () => {
  const [dashdata, setDashData] = useState([]);
  const swal = useSwalWrapper();
  const { authToken } = useJumboAuth();
  // console.log(jumboco);
  useEffect(async () => {
    authToken &&
      jwtAuthAxios
        .get("/master/dashboard")
        .then((res) => {
          setDashData(res.data.rows);
        })
        .catch((e) => {
          swal.fire({
            icon: "error",
            text: e,
          });
        });
  }, [authToken]);

  const Item = styled("div")(({ theme }) => ({
    color: theme.palette.common.black,
    marginBottom: 16,
    width: "15.5%",
    [theme.breakpoints.down("lg")]: {
      width: "16.5%",
    },
    [theme.breakpoints.down("md")]: {
      width: "33.3%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "50%",
    },
    padding: theme.spacing(0, 2),
  }));
  const theme = useTheme();



  return (
    <>
      {dashdata?.length > 0 ? (
        <>
          <AdminDashboard />
          {/* <AccountDashboard /> */}
          {/* <SalesmanDashboard /> */}
          {/* <UserDashboard />  */}
        </>
      ) : (
        "Loading Dashboard...."
      )}
    </>
  );
};
Dashboard.Modulename = "Dashboard";
export default Dashboard;
